import InfoIcon from '@material-ui/icons/Info';

export default InfoIcon